import React, { useEffect, useState } from "react";
import "./Approach.css";

const Approach = () => {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowContent(true);
      } else {
        setShowContent(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="approach-section">
      
      {/* Sticky Image */}
      <div className="approach-sticky">
        <img
          src="/images/school-children.jpg"
          alt=""
        />

        {/* Gradient Overlay */}
        <div className={`overlay ${showContent ? "active" : ""}`} />

        {/* Content */}
        <div className={`approach-content ${showContent ? "show" : ""}`}>
          <span className="badge">OUR APPROACH</span>

          <h2>Powered By People</h2>

          <p>
            Our approach keeps people at the center always.
          </p>

          <div className="features">
            <div>
              <h4>Listen First</h4>
              <p>We listen to people and understand their challenges.</p>
            </div>

            <div>
              <h4>Build With Intention</h4>
              <p>We co-create meaningful solutions with communities.</p>
            </div>

            <div>
              <h4>Measure What Matters</h4>
              <p>We ensure real and lasting impact.</p>
            </div>
          </div>

         <a href="#contact">
  <button className="cta">
    Join Us <span>→</span>
  </button>
</a>
        </div>
      </div>

      {/* Extra scroll space */}
      <div className="spacer"></div>
    </section>
  );
};

export default Approach;